import {  createSlice } from "@reduxjs/toolkit";

const initialState = {
  notifications: [],
};
export const UISlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    addNotification: (state, { payload }) => {
      state.notifications.push(payload);
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    deleteNotification: (
      state,
      { payload }
    ) => {
      state.notifications = state.notifications.filter(
        (x) => x.id !== payload?.id
      );
    },
  },
});

export const { addNotification, clearNotifications, deleteNotification } =
  UISlice.actions;

export default UISlice.reducer;
